import { render, staticRenderFns } from "./InvoiceApi.vue?vue&type=template&id=62d44e8f&scoped=true"
import script from "./InvoiceApi.vue?vue&type=script&lang=js"
export * from "./InvoiceApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d44e8f",
  null
  
)

export default component.exports